// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 427) return "static/chunks/427-0e632c75211bb36a.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"586":"b3263da6","832":"e22d3d1b"}[chunkId] || chunkId) + "." + {"352":"614847a573359c79","586":"c03c1a850985eadc","832":"6ca16ef7e89381eb","914":"cfe135fe01ac88b8"}[chunkId] + ".js";
};